// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"529":"e31bdb7d","756":"0336a93e","765":"eb155b2b","851":"e5c19dfd"}[chunkId] + ".chunk.js";
};